import postRequest from '../../../../../../postRequest';

/**
 * Bulk upload a Categories to multiple products.
 *
 * @param {{
 *  referenceIds: string[],
 *  categoryId: number[],
 *  siteId: number,
 *  languageId: number,
 * }}
 * @param {string[]} referenceIds Product Ids
 * @param {number[]} categoryId Category Ids
 * @param {number} siteId Site Id
*/
export default function postCategoriesProductId({
  referenceIds,
  categoryId,
  siteId,
}) {
  const endpoint = '/oc-product-bulkapi/v1/bulk-process/categories/product-id';

  const body = {
    referenceIds,
    categoryId,
    siteId,
    languageId: 0,
  };

  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'Categories (ProductId)', 'Started : Categories : Prod ID (Update)')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
